import React from "react";
import "./Nav1.scss";
import { Box, Container, Grid, HStack, Text } from "@chakra-ui/layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faNotesMedical } from "@fortawesome/free-solid-svg-icons";
import { Avatar } from "@chakra-ui/avatar";
import { Button } from "@chakra-ui/button";

const Nav1 = () => {
  return (
    <Box w="100%" bg="#f2f2f2">
      <Container maxW="container.xl" py={2.5}>
        <Grid justifyItems="flex-end">
          <HStack spacing="5">
            <Box>
              <FontAwesomeIcon icon={faNotesMedical} />
            </Box>
            <Box>
              <Button
                sx={{
                  bg: "white",
                  color: "black",
                  border: "1px xolid #00A2E8",
                }}
              >
                Create Event
              </Button>
            </Box>
            <HStack>
              <Avatar src="/images/essex_logo.png"></Avatar>
              <Text>University of Essex</Text>
            </HStack>
          </HStack>
        </Grid>
      </Container>
    </Box>
  );
};

export default Nav1;
